<template>
	<div class="block-with-icon">
		<div :class="['icon', item.icon]"></div>
		<div class="wrapper">
			<div class="title">{{ item.order }}) {{ item.title }}</div>
			<div class="description" v-html="item.description"></div>
			<div class="description f15" v-if="item.hint" v-html="item.hint"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'HowItWorksItem',
	props: {
		item: {
			type: Object,
			required: true
		}
	}
}
</script>

<style scoped></style>
